module.exports = {
  es: {
    locale: 'es',
    path: 'es',
    label: 'Español',
    abbr: 'Es',
    default: true,
    routes: {
      '/': '/',
      '/estados/': '/state-crime/',
      '/homicidios-mujeres/': '/female-homicides/',
      '/feminicidio/': '/feminicides/',
      '/mapa-de-delincuencia/': '/violence-map/',
      '/mapa-clusters/': '/cluster-map/',
      '/municipios/': '/municipios/',
      '/municipios-mas-violentos/': '/most-violent-cities/',
      '/anomalias/': '/anomalies/',
      '/tendencias/': '/trends/',
      '/envipe/': '/underreporting-crime/',
      '/infograficas/': '/infographics/',
      '/acerca/': '/about/',
      '/turismo/': '/tourism/'
    },
  },
  en : {
    locale: 'en',
    path: 'en',
    label: 'English',
    abbr: 'En',
    routes: {
      '/': '/',
      '/estados/': '/state-crime/',
      '/homicidios-mujeres/': '/female-homicides/',
      '/feminicidio/': '/feminicides/',
      '/mapa-de-delincuencia/': '/violence-map/',
      '/mapa-clusters/': '/cluster-map/',
      '/municipios/': '/municipios/',
      '/municipios-mas-violentos/': '/most-violent-cities/',
      '/anomalias/': '/anomalies/',
      '/tendencias/': '/trends/',
      '/envipe/': '/underreporting-crime/',
      '/infograficas/': '/infographics/',
      '/acerca/': '/about/',
      '/turismo/': '/tourism/'
    },
  }
}
